import type { SuretyBondId } from "@inrev/common";
import { bondAttachmentsQueryKey } from "../bond/bond.keys";
import { type AttachmentActionsConfig, useAttachmentActions } from "./useAttachmentActions";

type UseBondAttachmentActionsConfig = {
	bondId: SuretyBondId;
	isAdmin: boolean;
	allowDelete?: boolean;
	allowUpload?: boolean;
	allowTypeConfirmation?: boolean;
};

export function useBondAttachmentActions({
	bondId,
	isAdmin,
	allowDelete,
	allowUpload,
	allowTypeConfirmation,
}: UseBondAttachmentActionsConfig): AttachmentActionsConfig {
	const baseUrl = `/v2/${isAdmin ? "admin/" : ""}surety/bonds/${bondId}/attachments`;

	return useAttachmentActions({
		uploadUrl: baseUrl,
		downloadBaseUrl: baseUrl,
		downloadQueryKeyPrefix: isAdmin ? "adminBondAttachments" : "bondAttachments",
		invalidateQueryKeys: [bondAttachmentsQueryKey(bondId)],
		allowDelete: allowDelete ?? isAdmin,
		allowUpload: allowUpload ?? true,
		allowTypeConfirmation: allowTypeConfirmation ?? isAdmin,
	});
}
